import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * usePageviewTracker
 *
 * SPA-aware pageview tracker. GA4's `gtag('config', ...)` call in
 * `public/index.html` only fires a single pageview on initial load, so
 * client-side route changes need to be reported manually. We also emit
 * a PostHog `$pageview` as a fallback so the two analytics tools stay
 * in sync across the SPA.
 *
 * Usage: call this hook once inside a component that lives *inside* the
 * React Router context (so `useLocation` works), e.g. a tiny component
 * rendered inside `<BrowserRouter>`.
 */
export function usePageviewTracker() {
  const location = useLocation();

  useEffect(() => {
    const pagePath = location.pathname + location.search;

    if (typeof window !== 'undefined') {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'page_view', {
          page_path: pagePath,
          page_location: window.location.href,
          page_title: document.title,
        });
      }

      if (window.posthog && typeof window.posthog.capture === 'function') {
        window.posthog.capture('$pageview', {
          $current_url: window.location.href,
          path: pagePath,
        });
      }
    }
  }, [location.pathname, location.search]);
}

export default usePageviewTracker;
